import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import endPoints from '../../modules/ajio-util/endpoints';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser
} from '../../modules/ajio-fetch/utils';
import { tokenReCreateParser } from '../../modules/ajio-fetch/utils';
import { getSafeFunction } from '../../utils/higherOrder';

const _safeFetchGetJSONResHandler = getSafeFunction(fetchGetJSONResHandler);
const _safeFetcher = getSafeFunction(fetcher);
const _safelyLinkEnroll = getSafeFunction(linkEnrollJP);
const _tokenReCreateParser = getSafeFunction(tokenReCreateParser);

function updateJioPrimeInformation(jioprimeConfig) {
  return {
    type: 'UPDATE_STORE_CREDIT_FOR_JIO_PRIME',
    jioprimeConfig
  };
}
function updateProfileInfo(updatedConfig) {
  return {
    type: 'UPDATE_JIOPRIME_PROFILE_INFO',
    updatedConfig
  };
}

function updateRecords(recordMetaData = {}) {
  let {
    response: recordObj = {},
    type: recordType = 'pending',
    currentPage = 0,
    pageSize = 10,
    retainExistingRecord = false
  } = recordMetaData;

  return {
    type: 'UPDATE_JIO_PRIME_RECORDS',
    recordObj,
    recordType,
    currentPage,
    pageSize,
    retainExistingRecord
  };
}

export function resetExisitingTransaction(recordMetaData = {}) {
  let { type: recordType = 'pending' } = recordMetaData;
  return {
    type: 'RESET_JIO_PRIME_RECORDS',
    recordType
  };
}

function updateBalance(balance) {
  return {
    type: 'GET_JIO_PRIME_POINTS',
    balance
  };
}

export function updateStoreForJPP(enrollLinkObj) {
  return dispatch => {
    dispatch({
      jioPrimeLinking: enrollLinkObj.jioPrimeLinking,
      type: 'LINKING_JIO_PRIME'
    });
  };
}

export function linkOrEnrollToJioPrime(enrollLinkObj, cb) {
  return async dispatch => {
    dispatch(showLoader('layout-loader'));

    let response = await _safelyLinkEnroll(async error => {
      let { statusCode } = error;
      if (statusCode === 401) {
        await _tokenReCreateParser(() => {}, statusCode);
        return await linkOrEnrollToJioPrime(enrollLinkObj)(dispatch);
      }
      let errorObj = await errorParser(error, statusCode);
      dispatch(hideLoader('layout-loader'));
      showErrorMessageInfo(errorObj, dispatch);
    }, enrollLinkObj);
    dispatch(
      updateJioPrimeInformation({
        jioPrimeLinked: response.linkedToAjio,
        jioPrimeRegistered: response.registerdJio,
        jioPrimeEnabled: response.jioPrimeEnabled
      })
    );
    dispatch(
      updateProfileInfo({
        jioPrimeLinked: response.linkedToAjio,
        jioPrimeRegistered: response.registerdJio,
        jioPrimeEnabled: response.jioPrimeEnabled
      })
    );
    dispatch(hideLoader('layout-loader'));
    let { jioPrimeResponse = '' } = response;

    if (jioPrimeResponse.length) {
      showErrorMessageInfo(
        {
          errorType: 'info',
          message: jioPrimeResponse
        },
        dispatch
      );
    }
    if (cb) {
      cb(JSON.stringify({ errorType: 'info', message: jioPrimeResponse }));
    }
    if (response.linkedToAjio && response.registerdJio) {
      showErrorMessageInfo(
        {
          errorType: 'info',
          message: 'Congratulations! Your Jio Prime Points account is created.'
        },
        dispatch
      );
      if (!cb) {
        window.history.replaceState({}, document.title, '?linked=true');
        return await getActivePoints({ isRequestOrginIsBrowser: true })(dispatch);
      }
    }
  };
}

function showErrorMessageInfo(errorObj = {}, dispatch) {
  dispatch(setErrorObject(errorObj));
  let timeOut = setTimeout(() => {
    dispatch(setErrorObject({}));
    clearTimeout(timeOut);
  }, 5000);
}

async function linkEnrollJP(body) {
  let response = await fetcher(
    `/api/jio-prime-point/enroll-link-jioprime`,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'include'
    })
  );
  response = await _safeFetchGetJSONResHandler(async error => {
    let statusCode = getErrorStatusCode(error);
    let errorObj = await errorParser(error, statusCode);
    return Promise.reject({
      ...errorObj,
      statusCode
    });
  }, response);

  return response;
}

export function getActivePoints(requestObj) {
  return async dispatch => {
    let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
    let apiEndPoint = `/api/jio-prime-point/active-pending-points`;
    let body = {};
    if (isRequestOrginIsBrowser) {
      dispatch(showLoader('credits-loader'));
    } else {
      let { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/jio-prime-point/active-pending-points`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U
      };
    }

    let response = await fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      })
    );

    response = await _safeFetchGetJSONResHandler(async error => {
      let statusCode = getErrorStatusCode(error);
      if (statusCode === 401) {
        await _tokenReCreateParser(() => {}, statusCode);
        return await getActivePoints(requestObj)(dispatch);
      }
      let errorObj = await errorParser(error, statusCode);
      dispatch(updateBalance({ responseCode: statusCode }));
      return Promise.reject({
        ...errorObj,
        statusCode
      });
    }, response);
    if (parseInt(response.responseCode) === 200) {
      dispatch(updateBalance(response));
    } else if (parseInt(response.responseCode) === 202) {
      response = {
        ...response,
        message: 'Unable to load  your Jio Prime Points. Please try again.',
        errorType: 'info'
      };
      showErrorMessageInfo(response, dispatch);
    } else if (parseInt(response.responseCode) > 400) {
      response = {
        ...response,
        activePoints: '-',
        pendingAmount: '-',
        pendingPoints: '-',
        redeemableAmount: '-'
      };
      showErrorMessageInfo(
        { message: 'Unable to load  your Jio Prime Points. Please try again.', errorType: 'info' },
        dispatch
      );
      dispatch(updateBalance(response));
    } else {
      response = {};
    }
    return response;
  };
}

export function getPointsTransaction(requestObj, cb) {
  return async dispatch => {
    let {
      isRequestOrginIsBrowser = false,
      request = {},
      type = 'pending',
      pageSize = 10,
      currentPage = 0,
      loader = true,
      retainExistingRecord = false
    } = requestObj;

    let apiEndPoint = `/api/jio-prime-point/get-redemeption-list`;

    let body = {
      type,
      startRowNum: currentPage * pageSize + 1,
      endRowNum: (currentPage + 1) * pageSize
    };

    if (isRequestOrginIsBrowser && loader) {
      dispatch(showLoader('jio-prime-transaction-list-loader'));
    }

    if (!isRequestOrginIsBrowser) {
      let { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/jio-prime-point/get-redemeption-list`;
      body = {
        ...body,
        A: request.cookies.A,
        U: request.cookies.U
      };
    }

    let response = await fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      })
    );

    response = await _safeFetchGetJSONResHandler(async error => {
      let statusCode = getErrorStatusCode(error);
      if (statusCode === 401) {
        await _tokenReCreateParser(() => {}, statusCode);
        return await getPointsTransaction(requestObj, cb)(dispatch);
      }
      let errorObj = await errorParser(error, statusCode);
      if (isRequestOrginIsBrowser && loader) {
        dispatch(hideLoader('jio-prime-transaction-list-loader'));
      }
      return Promise.reject({
        ...errorObj,
        statusCode
      });
    }, response);

    if (parseInt(response.responseCode) === 200) {
      dispatch(updateRecords({ response, type, currentPage, pageSize, retainExistingRecord }));
    }
    if (cb) {
      cb();
    }

    if (isRequestOrginIsBrowser && loader) {
      dispatch(hideLoader('jio-prime-transaction-list-loader'));
    }
    return response;
  };
}

export function getQuestions(requestObj, callback) {
  return async dispatch => {
    let { statusCode = 'jioprime' } = requestObj;

    let apiEndPoint = `/api/jio-prime-point/get-question-answer/${statusCode}`;
    dispatch(showLoader('jio-prime-transaction-list-loader'));
    let response = await fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    );

    response = await _safeFetchGetJSONResHandler(async error => {
      let statusCode = getErrorStatusCode(error);
      dispatch(hideLoader('jio-prime-transaction-list-loader'));
      let errorObj = await errorParser(error, statusCode);
      if (statusCode === 401) {
        tokenReCreateParser(statusCode, errorObj).then(() => {
          getQuestions(requestObj, callback)(dispatch);
        });
      }
      return Promise.reject({
        ...errorObj,
        statusCode
      });
    }, response);
    if (callback) {
      callback(response);
    }
    dispatch(hideLoader('jio-prime-transaction-list-loader'));
  };
}
